export default {
  circular: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif',
};
